module.exports = __webpack_public_path__ + "img/examen_pratique.eb8aac49.png";